module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/rouble-1cc9a189f41e64147ad975ad44a27c97.svg";